import { WorkItemRequest, WorkItemResult } from '../../notification/work-item-request';
import { RpcBaseData } from '../rpc-base';

/**
 * RPC work item request name and version.
 */
export class RpcWorkItemKey {
    public static command = 'WorkItem';
    public static version = '0.1.0';
}

/**
 * Rpc work item data.
 */
export interface RpcWorkItem extends RpcBaseData, WorkItemRequest {
    /**
     * node name.
     */
    nodeName;

    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;
}

/**
 * Rpc work item result data.
 */
export interface RpcWorkItemResult extends WorkItemResult { }
